import defaultTheme from './defaultTheme';
const zulilyTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#87179D', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#87179D', background: '#87179D' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#87179D' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#87179D', border: '#87179D', background: '#87179D' }), field: {
        focus: '#87179D',
        label: '#87179D',
        icon: '#87179D',
    } });
export default zulilyTheme;
